import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ShActionItemComponent } from '../../../elements/components/action-item/action-item.component';
import { ShIconModule } from '../../../elements/components/icon/icon.module';

import { ShClickOutsideDirective } from '../../../elements/directives/click-outside/click-outside.directive';
import { ShFormTagListComplexBaseComponent } from './base-complex/form-tag-list-complex-base.component';
import { ShFormTagListBaseComponent } from './base-simple/form-tag-list-base.component';
import { ShFormTagListComponent } from './main/form-tag-list.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ShIconModule,
        ShActionItemComponent,
        ShFormTagListComponent,
        ShFormTagListBaseComponent,
        ShFormTagListComplexBaseComponent,
        ShClickOutsideDirective
    ],
    exports: [ShFormTagListComponent, ShFormTagListBaseComponent, ShFormTagListComplexBaseComponent]
})
export class ShFormTagListModule {}

export { ShFormTagListComplexBaseComponent } from './base-complex/form-tag-list-complex-base.component';
export { ShFormTagListBaseComponent } from './base-simple/form-tag-list-base.component';
export { ShFormTagListComponent } from './main/form-tag-list.component';
